import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFontAwesomeIcon, hasValue } from "@utils";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
/**
 * @export
 * A component that displays a chip with a label and optional icon, used for tags or filters.
 *
 * @example
 * ```
 * <Chip
 *   label="Filter"
 *   icon="filter"
 * />
 * ```
 *
 * @example
 * ```
 * <Chip
 *   label="Clickable Chip"
 *   icon="star"
 *   iconPosition="right"
 *   backgroundColor="#f0f0f0"
 *   textColor="#333"
 *   onClick={(e) => console.log('Chip clicked')}
 *   additionalStyles={{ borderRadius: '8px' }}
 * />
 * ```
 */
const Chip = (props) => {
    const { icon, label, iconPosition = 'left', variant = 'secondary', size = 'medium', backgroundColor, textColor, onClick, additionalStyles } = props;
    const handleClick = (e) => {
        if (onClick)
            onClick(e);
    };
    const chipStyle = Object.assign(Object.assign(Object.assign({}, (backgroundColor && { backgroundColor })), (textColor && { color: textColor })), additionalStyles);
    const iconElement = hasValue(icon)
        ? (_jsx("div", { className: "uxpcore_chip__icon", children: _jsx(FontAwesomeIconWrapper, { icon: getFontAwesomeIcon(icon) }) }))
        : null;
    const iconOnly = hasValue(icon) && !hasValue(label);
    const chipClasses = [
        'uxpcore_chip',
        `uxpcore_chip--${variant}`,
        `uxpcore_chip--${size}`,
        onClick && 'uxpcore_chip--clickable',
        iconOnly
            ? 'uxpcore_chip--icon-only'
            : hasValue(icon)
                ? `uxpcore_chip--icon-${iconPosition}`
                : 'uxpcore_chip--no-icon',
    ].filter(Boolean).join(' ');
    return (_jsxs("div", { className: chipClasses, style: chipStyle, onClick: handleClick, children: [!iconOnly && iconPosition === 'left' && iconElement, iconOnly ? iconElement : _jsx("div", { className: "uxpcore_chip__label", children: label }), !iconOnly && iconPosition === 'right' && iconElement] }));
};
export default Chip;
